__webpack_require__.p = "https://www.mashlim.org.il/";